import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { mixGetV1, mixPostV1 } from "services/mixin";
import { ToastContainer, toast } from "react-toastify";
import { getUnreadCount, NotificationData, getNotificationPageUnread, markAllAsRead } from "pages/Notifications/function";
import NotificationBox from "pages/Notifications/notificationBox";
import { Link } from "react-router-dom";
import { useDisconnect } from "wagmi";
import { deleteFmcToken } from "services/fmc_token_upload";
import { FirebaseNotificationToggle } from "pages/Notifications/notificationSwitch";


const NavbarHeader: React.FC = () => {
    const { t } = useTranslation();
    const [showActions, setShowActions] = useState(false);
    const [showMessages, setShowMessages] = useState(false); // Mặc định là đóng (false)
    const [isSidebarShown, setSidebarShown] = useState(false);
    const [username, setUsername] = useState<string>(() => {
        const userData = localStorage.getItem('user');
        if (!userData) return 'Unknown';
        try {
            const user = JSON.parse(userData);
            const first = user.first_name ?? '';
            const last = user.last_name ?? '';
            const full = `${first} ${last}`.trim();
            if (!full || full === 'null null') return user.username || 'Unknown';
            return full;
        } catch {
            return 'Unknown';
        }
    });
    const [emailUser, setEmailUser] = useState<string>(JSON.parse(localStorage.getItem('user') || '{}').email || '')
    const [avatarLetter, setAvatarLetter] = useState<string>('')
    const [idLast, setIdLast] = useState<number>()
    const [notificationList, setNotificationList] = useState<NotificationData[]>([])
    const [notificationCount, setNotificationCount] = useState<number>(0)
    const [notificationPage, setNotificationPage] = useState<number>(1)

    const wrapperRef = useRef<HTMLDivElement>(null);
    const wrapperRefMessages = useRef<HTMLDivElement>(null);
    const [avatar, setAvatar] = useState(JSON.parse(localStorage.getItem('user') || '{}').avatar_url || '')
    const [getName, setGetName] = useState<string>('')
    const { disconnect } = useDisconnect()

    useEffect(() => {
        const userData = localStorage.getItem('user');

        if (userData) {
            const user = JSON.parse(userData)

            setAvatar(user.avatar_url)
            const lang = localStorage.getItem('i18nextLng')

            if (lang === 'en') setGetName(`${user.first_name} ${user.last_name}`)
            if (lang === 'vi') setGetName(`${user.last_name} ${user.first_name}`)
        }

    }, [])

    const toggleActions = () => {
        setShowActions((prev) => !prev);
    };

    // Thêm e.stopPropagation() để tránh sự kiện click nổi bọt gây lỗi đóng/mở
    const toggleMessages = (e: React.MouseEvent) => {
        e.stopPropagation();
        setShowMessages((prev) => !prev);
    };

    const getIdLast = async () => {
        const res = await mixGetV1('/api/v1/be/point_ledger')

        if (res.status) {
            setIdLast(res.data.items[0].id)
        }
    }

    const buyPoint = async () => {
        getIdLast()

        const localeData = localStorage.getItem('user')

        if (localeData) {
            const id = JSON.parse(localeData).id

            const res = await mixPostV1('/api/v1/be/point_ledger/purchase', {
                "user_id": id,
                "provider": "bank_transfer",
                "amount_cents": 1000000,
                "currency": "VND",
                "status": "succeeded",
                "idempotency_key": `purchase_${idLast}`,
                "meta": { "note": "Topup 1000k" }
            })

            if (res.status) {
                toast.success('Purched point successful', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        }
    }

    useEffect(() => {
        getNotificationPageUnread(1, 10).then((unread) => {
            if (unread && typeof unread === 'object' && 'data' in unread && Array.isArray(unread.data)) {
                setNotificationList(unread.data);
            } else if (Array.isArray(unread)) {
                setNotificationList(unread);
            } else {
                setNotificationList([]);
            }
        });
        getUnreadCount().then((count) => {
            setNotificationCount(count);
        });
    }, []);

    async function loadMoreNotifications() {
        if (notificationList.length === 0) return;
        const nextPage = notificationPage + 1;
        const newNotifications = await getNotificationPageUnread(nextPage, 10);
        if (newNotifications && Array.isArray(newNotifications.data)) {
            setNotificationList((prev) => [...prev, ...newNotifications.data]);
        }
    }

    // Click outside để ẩn menu thông báo và quick actions
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(event.target as Node) &&
                wrapperRefMessages.current &&
                !wrapperRefMessages.current.contains(event.target as Node)
            ) {
                setShowActions(false);
                setShowMessages(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleToggle = () => {
        const htmlElement = document.documentElement; // <html>
        const sidebarElement = document.querySelector('#sidebar-main');

        if (!isSidebarShown) {
            htmlElement.classList.add('scroll-disabled');
            sidebarElement?.classList.add('shown');
        } else {
            htmlElement.classList.remove('scroll-disabled');
            sidebarElement?.classList.remove('shown');
        }

        setSidebarShown(!isSidebarShown);
    };

    return (
        <nav id="top-bar" className="navbar navbar--fixed navbar--main navbar--expand-lg" data-avatar-with-picture="false" style={{ top: 0 }}>

            <div className="container">
                <div className="navbar__content relative">
                    <button
                        type="button"
                        className={`sidebar-hamburger ${isSidebarShown ? 'sidebar-hamburger--active' : ''}`}
                        onClick={handleToggle}
                    >
                        <span className="sidebar-hamburger__icon"></span>
                    </button>
                    <Link to="/accounts-overview" className="logo-image-head">
                        {/* <img src="/images/logo-lumir-trang.svg" alt="logo" /> */}
                        <img src="/images/logo2.png" className="max-lg:hidden" alt="logo" />
                    </Link>

                    <div className="navbar__buttons">
                        <span
                            className="navbar-link nav-item text--medium d-none d-sm-flex cursor-pointer"
                            onClick={toggleActions}
                        >{getName}</span>
                        <div className="navbar-link nav-item cursor-pointer avatar  avatar--lg" onClick={toggleActions}>
                            <img src={avatar} alt="" className="avatar__img"
                                onError={(e) => {
                                    const img = e.currentTarget as HTMLImageElement;
                                    const fallback = document.createElement('div');
                                    fallback.className = 'avatar__img avatar__fallback';
                                    fallback.style.display = 'flex';
                                    fallback.style.alignItems = 'center';
                                    fallback.style.justifyContent = 'center';
                                    fallback.style.background = '#e9b460';
                                    fallback.style.color = '#fff';
                                    fallback.style.fontWeight = '700';
                                    fallback.style.fontSize = '32px';
                                    fallback.style.width = '100%';
                                    fallback.style.height = '100%';
                                    fallback.style.borderRadius = getComputedStyle(img).borderRadius || '50%';
                                    const svgns = "http://www.w3.org/2000/svg";
                                    const svg = document.createElementNS(svgns, "svg");
                                    svg.setAttribute("viewBox", "0 0 256 256");
                                    svg.setAttribute("xmlns", svgns);
                                    svg.setAttribute("width", "48");
                                    svg.setAttribute("height", "48");
                                    svg.style.maxWidth = "100%";
                                    svg.style.height = "auto";

                                    const rect = document.createElementNS(svgns, "rect");
                                    rect.setAttribute("width", "256");
                                    rect.setAttribute("height", "256");
                                    rect.setAttribute("fill", "none");

                                    const circle = document.createElementNS(svgns, "circle");
                                    circle.setAttribute("cx", "128");
                                    circle.setAttribute("cy", "96");
                                    circle.setAttribute("r", "64");
                                    circle.setAttribute("fill", "none");
                                    circle.setAttribute("stroke", "currentColor");
                                    circle.setAttribute("stroke-linecap", "round");
                                    circle.setAttribute("stroke-linejoin", "round");
                                    circle.setAttribute("stroke-width", "16");

                                    const path = document.createElementNS(svgns, "path");
                                    path.setAttribute("d", "M32,216c19.37-33.47,54.55-56,96-56s76.63,22.53,96,56");
                                    path.setAttribute("fill", "none");
                                    path.setAttribute("stroke", "currentColor");
                                    path.setAttribute("stroke-linecap", "round");
                                    path.setAttribute("stroke-linejoin", "round");
                                    path.setAttribute("stroke-width", "16");

                                    svg.appendChild(rect);
                                    svg.appendChild(circle);
                                    svg.appendChild(path);
                                    fallback.appendChild(svg);

                                    img.replaceWith(fallback);

                                }}
                                onLoad={(e) => {
                                    const img = e.currentTarget as HTMLImageElement;
                                    img.style.display = 'block';
                                }}
                            />
                        </div>

                        {/* Giữ nguyên cấu trúc nút chuông thông báo cũ, thêm điều khiển ẩn hiện và stopPropagation */}
                        <div className="navbar-link navbar-link__notifications nav-item notifications__toggle" onClick={toggleMessages}>
                            <div
                                ref={wrapperRefMessages}
                                className={`dropdown ${showMessages ? "open" : ""}`}
                                style={{
                                    position: 'absolute',
                                    top: '50px',
                                    right: '0',
                                    width: '392px',
                                    maxHeight: '520px',
                                    background: 'var(--card, #ffffff)',
                                    borderRadius: '16px',
                                    border: '1px solid var(--border, #e9e6dd)',
                                    boxShadow: '0 20px 45px -12px rgba(11,28,46,.28)',
                                    display: showMessages ? 'flex' : 'none',
                                    flexDirection: 'column',
                                    overflow: 'hidden',
                                    zIndex: 25
                                }}
                            >
                                <div className="dd-head" style={{ padding: '16px 18px 10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <FirebaseNotificationToggle />
                                    </div>
                                    <button className="mark-all" style={{ fontSize: '12px', color: 'var(--ink-soft, #5b6472)', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }} onClick={(e) => {
                                        e.stopPropagation();
                                        markAllAsRead().then(() => {
                                            setNotificationList((prev) => prev.map((n) => ({ ...n, is_read: true })));
                                            setNotificationCount(0);
                                        });
                                    }}>
                                        {t('Mark all as read')}
                                    </button>
                                </div>

                                <div className="dd-list" style={{ overflowY: 'auto', flex: 1, padding: '4px 10px 10px', maxHeight: '380px' }}>
                                    {notificationList.length === 0 ? (
                                        <div className="dd-empty" style={{ padding: '40px 20px', textAlign: 'center', color: '#93989f', fontSize: '13px' }}>
                                            {t('No new notifications')}
                                        </div>
                                    ) : (
                                        notificationList.map((notification) => (
                                            <NotificationBox
                                                id={notification.id.toString()}
                                                key={notification.id}
                                                title={notification.title}
                                                message={notification.message}
                                                isRead={notification.is_read}
                                                createdAt={notification.createdAt}
                                                redirect_url={notification.redirect_url || undefined}
                                            />
                                        ))
                                    )}
                                </div>

                                <div className="dd-foot" style={{ borderTop: '1px solid var(--border, #e9e6dd)', padding: '12px 18px', textAlign: 'center' }}>
                                    <Link to="/notifications" onClick={() => setShowMessages(false)} style={{ background: 'none', border: 'none', fontSize: '12.5px', fontWeight: 700, color: 'var(--navy, #0b1c2e)', textDecoration: 'none' }}>
                                        {t('See all')} →
                                    </Link>
                                </div>
                            </div>

                            {/* Huy hiệu số lượng chưa đọc */}
                            <span
                                data-notifications-target="notificationCount"
                                style={{
                                    display: notificationCount > 0 ? "flex" : "none",
                                    width: "18px",
                                    height: "18px",
                                    fontSize: "10px",
                                    backgroundColor: "var(--red, #e24b4a)",
                                    color: "#fff",
                                    borderRadius: "100%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    right: "-4px",
                                    top: "-3px",
                                    position: "absolute",
                                    pointerEvents: "none",
                                    userSelect: "none",
                                    fontWeight: 700,
                                    border: '2px solid var(--navy, #0b1c2e)'
                                }}
                            >
                                {notificationCount > 9 ? '9+' : notificationCount}
                            </span>
                        </div>
                    </div>

                    <div
                        id="quick-actions-profile"
                        ref={wrapperRef}
                        className={`quick-actions transition--fade-in ${showActions ? "faded-in" : ""
                            }`}
                        data-top-bar-action=""
                        data-toggle-on-click-outside=""
                    >
                        <div className="quick-actions__content">
                            <div className="quick-actions__header">
                                <div className="quick-actions__header-icon">
                                    <div className="avatar  avatar--xl">
                                        <img src={avatar} alt="" className="avatar__img"
                                            onError={(e) => {
                                                const img = e.currentTarget as HTMLImageElement;
                                                const fallback = document.createElement('div');
                                                fallback.className = 'avatar__img avatar__fallback';
                                                fallback.style.display = 'flex';
                                                fallback.style.alignItems = 'center';
                                                fallback.style.justifyContent = 'center';
                                                fallback.style.background = '#e9b460';
                                                fallback.style.color = '#fff';
                                                fallback.style.fontWeight = '700';
                                                fallback.style.fontSize = '32px';
                                                fallback.style.width = '100%';
                                                fallback.style.height = '100%';
                                                fallback.style.borderRadius = getComputedStyle(img).borderRadius || '50%';
                                                const svgns = "http://www.w3.org/2000/svg";
                                                const svg = document.createElementNS(svgns, "svg");
                                                svg.setAttribute("viewBox", "0 0 256 256");
                                                svg.setAttribute("xmlns", svgns);
                                                svg.setAttribute("width", "48");
                                                svg.setAttribute("height", "48");
                                                svg.style.maxWidth = "100%";
                                                svg.style.height = "auto";

                                                const rect = document.createElementNS(svgns, "rect");
                                                rect.setAttribute("width", "256");
                                                rect.setAttribute("height", "256");
                                                rect.setAttribute("fill", "none");

                                                const circle = document.createElementNS(svgns, "circle");
                                                circle.setAttribute("cx", "128");
                                                circle.setAttribute("cy", "96");
                                                circle.setAttribute("r", "64");
                                                circle.setAttribute("fill", "none");
                                                circle.setAttribute("stroke", "currentColor");
                                                circle.setAttribute("stroke-linecap", "round");
                                                circle.setAttribute("stroke-linejoin", "round");
                                                circle.setAttribute("stroke-width", "16");

                                                const path = document.createElementNS(svgns, "path");
                                                path.setAttribute("d", "M32,216c19.37-33.47,54.55-56,96-56s76.63,22.53,96,56");
                                                path.setAttribute("fill", "none");
                                                path.setAttribute("stroke", "currentColor");
                                                path.setAttribute("stroke-linecap", "round");
                                                path.setAttribute("stroke-linejoin", "round");
                                                path.setAttribute("stroke-width", "16");

                                                svg.appendChild(rect);
                                                svg.appendChild(circle);
                                                svg.appendChild(path);
                                                fallback.appendChild(svg);

                                                img.replaceWith(fallback);
                                            }}
                                            onLoad={(e) => {
                                                const img = e.currentTarget as HTMLImageElement;
                                                img.style.display = 'block';
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="quick-actions__header-body">
                                    <div className="quick-actions__header-titletext--contrast">
                                        {username}
                                    </div>
                                    <div className="quick-actions__header-subtitle">
                                        <i className="fi fi--user fi--primary quick-actions__header-body-icon"></i>
                                        <span className="text-break" id="quick-actions-profile-email">{emailUser}</span>
                                    </div>
                                    <div className="quick-actions__header-subtitle">
                                        <i className="fi fi--coin-stack fi--primary quick-actions__header-body-icon"></i>
                                        <span data-testid="points" className="quick-actions-points__total me-1">0</span>
                                        <span className="">LUMIR Points</span>
                                    </div>
                                </div>
                                <button type="button" className="btn btn--close top-bar__close top-bar__close--quick-actions" onClick={toggleActions}></button>
                            </div>
                            <div className="quick-actions__body">
                                <ul className="quick-actions__list">
                                    <li className="quick-actions__list-item">
                                        <Link to="/profile" className="quick-actions__item-link">
                                            <i className="fi fi--primary fi--user quick-actions__item-icon"></i>
                                            <div className="quick-actions__item-body">
                                                <div className="quick-actions__item-title">
                                                    {t('acc_title_profile')}
                                                </div>
                                                <div className="quick-actions__item-subtitle">
                                                    {t('acc_title_desc')}
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li className="quick-actions__list-item">
                                        <Link to="/profile/inventory" className="quick-actions__item-link">
                                            <i className="fi fi--primary fi--price-tag quick-actions__item-icon"></i>
                                            <div className="quick-actions__item-body">
                                                <div className="quick-actions__item-title">
                                                    {t('acc_inventory_title')}
                                                </div>
                                                <div className="quick-actions__item-subtitle">
                                                    {t('acc_inventory_desc')}
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li className="quick-actions__list-item !opacity-50 pointer-events-none">
                                        <Link to="#personalizationSettingModal" id="personalizationSettingButton" className="quick-actions__item-link" data-bs-toggle="modal">
                                            <i className="fi fi--primary fi--settings quick-actions__item-icon"></i>
                                            <div className="quick-actions__item-body">
                                                <div className="quick-actions__item-title">
                                                    {t('acc_personalisation_title')}
                                                </div>
                                                <div className="quick-actions__item-subtitle">
                                                    {t('acc_personalisation_desc')}
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="quick-actions__footer" style={{ padding: "0 24px" }}>
                                <div className="btn btn-primary w-100" data-clear-local-storage="true" onClick={buyPoint}>
                                    {t('acc_buy_point')}
                                </div>
                            </div>
                            <div className="quick-actions__footer">
                                <div onClick={async () => {
                                    try {
                                        await disconnect()
                                        await deleteFmcToken()
                                    } catch (error) {
                                        console.log('Error during disconnect or deleting FMC token:', error);
                                    }
                                    localStorage.removeItem('token')
                                    localStorage.removeItem('-walletlink:https://www.walletlink.org:session:id')
                                    localStorage.removeItem('-walletlink:https://www.walletlink.org:session:linked')
                                    localStorage.removeItem('-walletlink:https://www.walletlink.org:session:secret')
                                    localStorage.removeItem('wagmi.store')
                                    localStorage.removeItem('WCM_RECENT_WALLET_DATA')
                                    localStorage.removeItem('user')
                                    localStorage.removeItem('birthday')
                                    localStorage.removeItem('is_admin')
                                    window.location.href = '/sign-up'
                                }} className="btn btn-primary w-100" data-clear-local-storage="true">
                                    {t('acc_logout')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </nav>
    );
}

export default NavbarHeader;